// src/ui/MediaBlock.jsx
import React from "react";
import { buildImageUrl } from "../lib/strapi";

export default function MediaBlock({ file }) {
  if (!file) return null;
  const url = buildImageUrl(file);
  const mime = file.mime || "";
  const caption = file.caption || file.name || "";

  if (mime.startsWith("image/")) {
    return (
      <figure className="rounded-2xl overflow-hidden border bg-gray-50">
        <img src={url} alt={caption} className="w-full h-auto object-cover" loading="lazy" />
        {caption && <figcaption className="text-sm text-gray-500 p-3">{caption}</figcaption>}
      </figure>
    );
  }

  if (mime.startsWith("video/")) {
    return (
      <figure className="rounded-2xl overflow-hidden border bg-black">
        <video className="w-full h-auto" controls src={url} />
        {caption && <figcaption className="text-sm text-gray-500 p-3">{caption}</figcaption>}
      </figure>
    );
  }

  if (mime.startsWith("audio/")) {
    return (
      <figure className="rounded-2xl overflow-hidden border p-4 bg-white">
        <audio controls src={url} className="w-full" />
        {caption && <figcaption className="text-sm text-gray-500 mt-2">{caption}</figcaption>}
      </figure>
    );
  }

  // Fallback: downloadable file
  return (
    <a
      href={url}
      className="inline-flex items-center gap-2 rounded-xl border px-4 py-2 hover:bg-gray-50"
      download
    >
      <span className="font-medium">Download</span>
      <span className="text-gray-500 text-sm">{caption}</span>
    </a>
  );
}
